<template>
  <li
    v-show="!select.query"
    class="el-select-dropdown__item"
    :class="{
      'selected': itemSelected
    }"
    @mouseenter="hoverItem"
    @click.stop="selectOptionClick"
  >
    <slot>
      <span>{{ label }}</span>
    </slot>
  </li>
</template>

<script>
  export default {
    name: 'ElSelectAllOption',
    inject: ['select'],
    computed: {
      visibleOptions () {
        return this.select.options.filter(option => !option.disabled)
      },
      itemSelected () {
        return this.select.value.length && this.select.value.length === this.visibleOptions.length
      }
    },
    props: {
      label: {
        type: [String, Number],
        default: '所有选项'
      }
    },
    methods: {
      hoverItem () {
        this.select.hoverIndex = null
        this.select.hoverOption = null
      },
      selectOptionClick () {
        const value = this.itemSelected ? [] : this.visibleOptions.map(option => option.value)

        this.select.$emit('input', value)
        this.select.emitChange(value)
      }
    }
  }
</script>